import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router, Params} from "@angular/router";
import {UtilitiesService} from "../core/_services/utilities.service";
import {AuthService} from "../core/_services/auth.service";
import {UserService} from "../core/_services/user.service";
import {USER_EVENT_TYPE} from "../core/constants";
import {EventTrackingService} from '../core/_services/event-tracking.service';

@Component({
    selector: 'app-dynamic',
    templateUrl: './dynamic.component.html'
})
export class DynamicComponent implements OnInit {

    token: any = null;
    value: any = null;

    busy = false;

    constructor(private utilitiesService: UtilitiesService,
        private authService: AuthService,
        private userService: UserService,
        private eventTrackingService: EventTrackingService,
        private route: ActivatedRoute,
        private router: Router) {

        this.route.params.forEach((params: Params) => {
            this.token = params['token'];
        });

        this.route.queryParams.forEach((params: Params) => {
            this.value = params['v'];
        });
    }

    ngOnInit() {
        this.busy = true;
        // must have a token
        if (this.utilitiesService.isEmpty(this.token)) {
            this.router.navigate(['/login']);
            return;
        }

        let params = {token: this.token, tokenType: "wrench"};
        this.authService.authenticateToken(params).subscribe((response: any) => {
            if (response.responseCode == 100) {
                // replace the token if appropriate
                this.authService.replaceCurrentToken(response.token).then(replacedToken => {
                    if (replacedToken) {
                        this.userService.getUser().subscribe(() => {
                            this.handleRedirect(response);
                        }, (error: any) => {
                            UtilitiesService.consoleLog(error);
                            this.handleRedirect(response);
                        });
                    } else {
                        this.handleRedirect(response);
                    }
                });
            } else {
                this.router.navigate(['/login']);
            }
        }, error => {
            this.router.navigate(['/appointments']);
        });

    } // ngOnInit()

    handleRedirect(response: any) {
        let urlParts = response.target.split("?");
        let target = urlParts[0];
        let queryParams: any = {};
        if (!this.utilitiesService.isEmpty(this.value)) {
            queryParams.value = this.value;
        }
        if (urlParts.length > 1) {
            // get params
            let paramsArray = urlParts[1].split("&");
            paramsArray.forEach((value: any) => {
                let keyValueArray = value.split("=");
                if (keyValueArray.length == 2) {
                    queryParams[keyValueArray[0]] = keyValueArray[1];
                }
            });
        }

        // save promo code if we have one
        this.savePromoCode(queryParams.promo);

        if (target == "app.nps") {
            this.npsRedirect(queryParams);
        } else if (target.startsWith("app.")) {
            this.oldSchoolRedirect(target, queryParams);
        } else {
            this.router.navigate([target], { queryParams });
        }
    }

    npsRedirect(data: any) {

        if (this.utilitiesService.isEmpty(data.jobId) || this.utilitiesService.isEmpty(data.value)) {
            this.router.navigate(['']);
            return;
        }

        let redirectRoute = data.value > 8 ? '/discounts' : '/feedback';
        let userId = this.authService.getUserIdFromToken();

        // call user nps
        let params = {userId: userId, jobId: data.jobId, recommend: data.value};
        this.userService.nps(params).subscribe((response: any) => {
            // redirect somewhere
            this.userService.jobId = data.jobId;
            this.userService.userServiceRating = data.value;
            this.router.navigate([redirectRoute]);
        }, error => {
            // redirect somewhere
            this.userService.jobId = data.jobId;
            this.userService.userServiceRating = data.value;
            this.router.navigate([redirectRoute]);
        });

    } // ngRedirect()

    oldSchoolRedirect(target: any, params: any) {
        let finalDesitnation = "";
        let queryParams: any = {};
        switch (target) {
            case "app.appointments":
                finalDesitnation = "/appointments";
                break;
            case "app.mechanicprofile":
                finalDesitnation = "/appointments/" + params.jobId + "/mechanic";
                break;
            case "app.activeappointment":
                finalDesitnation = "/appointments/" + params.jobId;
                queryParams.jobId = params.jobId;
                queryParams.active = true;
                break;
            case "app.appointmentdetails":
                finalDesitnation = "/appointments/" + params.jobId;
                break;
            case "app.ratemechanic":
                finalDesitnation = "/appointments/" + params.jobId + "/mechanic/rate";
                break;
            case "app.changeappointment":
                finalDesitnation = "/appointments/" + params.jobId + "/change";
                break;
            case "app.servicehistory":
                finalDesitnation = "/history/" + params.jobId;
                break;
            case "app.book":
                finalDesitnation = "/book";
                break;
            case "app.quotes":
                if (!this.utilitiesService.isEmpty(params.jobRequestId)) {
                    finalDesitnation = "/quotes/" + params.jobRequestId;
                } else {
                    finalDesitnation = "/quotes";
                }
                break;
            default:
                break;
        }
        if (UtilitiesService.isNotEmpty(queryParams)) {
            this.router.navigate([finalDesitnation], {queryParams: queryParams});
        } else {
            this.router.navigate([finalDesitnation]);
        }

    } // oldSchoolRedirect()

    private savePromoCode(promoCode: any) {

        // add discount code
        if (!this.utilitiesService.isEmpty(promoCode)) {

            const userId = this.authService.getUserIdFromToken();
            if (!this.utilitiesService.isEmpty(userId)) {
                let params = {userId: userId, promoCode: promoCode};
                this.userService.applyPromoCode(params).subscribe((result: any) => {
                    if (result.responseCode == 100) {
                        let trackParams = {
                            type: USER_EVENT_TYPE.ADD_DISCOUNT.value,
                            name: USER_EVENT_TYPE.ADD_DISCOUNT.label,
                            ga: {action: 'add discount', properties: {category: "discounts", label: "success"}},
                            internal: {
                                endpoint: '/transaction/applypromocode',
                                endpointParams: params
                            }
                        };
                        this.eventTrackingService.trackEvent(trackParams);
                    } else {
                        if (result.responseCode == 202) {
                            let trackParams = {
                                type: USER_EVENT_TYPE.ADD_DISCOUNT.value,
                                name: USER_EVENT_TYPE.ADD_DISCOUNT.label,
                                ga: {action: 'add discount', properties: {category: "discounts", label: "error - invalid discount code"}},
                                internal: {
                                    endpoint: '/transaction/applypromocode',
                                    endpointParams: params
                                }
                            };
                            this.eventTrackingService.trackEvent(trackParams);
                        } else if (result.responseCode == 502) {
                            let trackParams = {
                                type: USER_EVENT_TYPE.ADD_DISCOUNT.value,
                                name: USER_EVENT_TYPE.ADD_DISCOUNT.label,
                                ga: {action: 'add discount', properties: {category: "discounts", label: "error - ineligible for discount"}},
                                internal: {
                                    endpoint: '/transaction/applypromocode',
                                    endpointParams: params
                                }
                            };
                            this.eventTrackingService.trackEvent(trackParams);
                        } else {
                            let trackParams = {
                                type: USER_EVENT_TYPE.ADD_DISCOUNT.value,
                                name: USER_EVENT_TYPE.ADD_DISCOUNT.label,
                                ga: {action: 'add discount', properties: {category: "discounts", label: "error"}},
                                internal: {
                                    endpoint: '/transaction/applypromocode',
                                    endpointParams: params
                                }
                            };
                            this.eventTrackingService.trackEvent(trackParams);
                        }
                    }
                }, error => {
                    let trackParams = {
                        type: USER_EVENT_TYPE.ADD_DISCOUNT.value,
                        name: USER_EVENT_TYPE.ADD_DISCOUNT.label,
                        ga: {action: 'add discount', properties: {category: "discounts", label: "error"}},
                        internal: {
                            endpoint: '/transaction/applypromocode',
                            endpointParams: params
                        }
                    };
                    this.eventTrackingService.trackEvent(trackParams);
                });
            } else {
                this.utilitiesService.setLocal("promoCodes", JSON.stringify([promoCode]));
            }

        }

    } // savePromoCode()

}
